import { FiClipboard } from "react-icons/fi";
import { Prescription } from "../../../../types";

interface WorkoutPlanFooterProps {
  prescriptions: Prescription[];
  initialData?: { id?: number } | null;
  loading: boolean;
  onClose: () => void;
}

export const WorkoutPlanFooter = ({
  prescriptions,
  initialData,
  loading,
  onClose,
}: WorkoutPlanFooterProps) => {
  return (
    <div className="border-t border-stroke bg-white px-3 py-3 dark:border-strokedark dark:bg-boxdark sm:px-4 sm:py-4 md:px-8 md:py-5">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
        {/* Info - Mobile First */}
        <div className="text-xs text-gray-600 dark:text-gray-400 text-center sm:text-left sm:text-sm">
          {prescriptions.length > 0 && (
            <span>
              <strong className="font-semibold text-gray-900 dark:text-white">
                {prescriptions.length}
              </strong>{" "}
              {prescriptions.length === 1 ? "treino" : "treinos"} •{" "}
              <strong className="font-semibold text-gray-900 dark:text-white">
                {prescriptions.reduce((acc, p) => acc + p.exercises.length, 0)}
              </strong>{" "}
              exercícios
            </span>
          )}
        </div>

        {/* Buttons - Mobile First */}
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full min-h-[48px] rounded-xl border-2 border-stroke px-4 py-2.5 text-sm font-semibold text-gray-700 transition-all active:bg-gray-50 touch-manipulation dark:border-strokedark dark:text-white dark:active:bg-meta-4 sm:min-h-0 sm:w-auto sm:rounded-xl sm:px-6 sm:py-3 sm:text-base md:hover:bg-gray-50 md:dark:hover:bg-meta-4"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="w-full min-h-[48px] inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-purple-600 to-purple-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-all active:scale-95 touch-manipulation disabled:opacity-50 disabled:active:scale-100 sm:min-h-0 sm:w-auto sm:rounded-xl sm:px-8 sm:py-3 sm:text-base md:hover:scale-105 md:hover:shadow-xl md:disabled:hover:scale-100"
          >
            {loading ? (
              <>
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                Salvando...
              </>
            ) : (
              <>
                <FiClipboard size={16} className="sm:w-[18px] sm:h-[18px]" />
                {initialData ? "Atualizar Plano" : "Criar Plano"}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
